module.exports = __webpack_public_path__ + "img/gc_country_flag_gr.7f1a200b.svg";